import { render } from "./CustomerSegmentation.vue?vue&type=template&id=ef0d60d0&ts=true"
import script from "./CustomerSegmentation.vue?vue&type=script&lang=ts"
export * from "./CustomerSegmentation.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__